// extracted by mini-css-extract-plugin
module.exports = {"option":"menu-option-plan_option__3UFz1","optionHeader":"menu-option-plan_optionHeader__3WS76","optionHeaderLabel":"menu-option-plan_optionHeaderLabel__30vRU"};